<app-project-submenu></app-project-submenu>

<p
  class="text-muted mt-3 mb-3"
  i18n="@@quiz-history-description"
  >
    Übersicht des projektweiten Quiz-Verlaufs pro Nutzer. Klicke auf einen Nutzer, um die vollständige Frage-Historie
    einzusehen.
</p>

<p-table
  [value]="this.userSummaries"
  [rowHover]="true"
  class="p-datatable-m"
  >
  <ng-template #header>
    @if (this.userSummaries.length > 0) {
      <tr>
        <th i18n="@@quiz-user-column">Nutzer</th>
        <th i18n="@@quiz-asked-column">Gefragt</th>
        <th i18n="@@quiz-right-column">Richtig</th>
        <th i18n="@@quiz-wrong-column">Falsch</th>
        <th i18n="@@last-activity-column">Letzte Aktivität</th>
      </tr>
    }
  </ng-template>

  <ng-template
    #body
    let-user
    >
    <tr
      style="cursor: pointer"
      (click)="openUser(user.userId)"
      >
      <td><strong>{{ user.userName }}</strong></td>
      <td>{{ user.askedCount }}</td>
      <td>{{ user.rightCount }}</td>
      <td>{{ user.wrongCount }}</td>
      <td>{{ user.lastActivity | date:'dd.MM.yyyy HH:mm' }}</td>
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td
        colspan="5"
        class="text-center p-5 text-muted"
        i18n="@@quiz-history-empty-state"
        >
                Noch kein Quiz-Verlauf vorhanden. Sobald Nutzer ein Quiz beantworten, erscheinen sie hier.
            </td>
    </tr>
  </ng-template>
</p-table>
